import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import Game from "./game/Game";
import {useSizeItem, useViewPortState} from "./provider/ResizeProvider";
// @ts-ignore
import videoFile from './assets/video_live_background.mp4';
import {StartScreen} from "./screens/StartScreen/StartScreen";
import {ScreenTypes, useAppContext} from "./provider/AppProvider";
import {Button} from "./components/Button";
import {eventEmitter} from "./EventEmitter";
import {useYandexSdk} from "./provider/yandex/yandexSdk";
import {getSizeForLayout} from "./utils/getSizeForLayout";
import {LanguageModal} from "./game/Modals/LanguageModal";

//ya top 32
//ya bot 50

const AppBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
`;

const BackgroundVideo = styled.video`
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left;
    transform: translate(-50%, -50%);
    z-index: -1;
`;

const InstrumentPanel = styled.div<{ screen: ScreenTypes }>`
    display: flex;
    justify-content: ${({screen}) => screen === 'start' ? 'flex-end' : 'space-between'};
    padding: ${({screen}) => screen === 'start' ? 0 : `0px 16px`};
    gap: 8px;
    width: 100%;
    position: absolute;
    top: 8px;
    right: ${({screen}) => screen === 'start' ? '16' : '0'}px;
    z-index: 10;
`;

const ButtonWrapper = styled.div`
    width: 50px;
    height: 50px;

    @media (min-width: 768px) {
        width: 100px;
        height: 100px;
    }
`;

function App() {
    const {isTableState, isDesktopState} = useViewPortState();
    const {yandexSdk} = useYandexSdk();
    const {
        screen,
        lang,
        onSwitchSound,
        sound,
        onSwitchSettings,
        onSwitchLeaderBord,
        ideaIsProcessing,
        setIdeaProcessing,
        onStopMusic,
        onPlayMusic,
    } = useAppContext();
    const [isShowLanguageModal, setShowLanguageModal] = useState(false);
    const {itemSize} = useSizeItem();

    useEffect(() => {
        yandexSdk.adv.showFullscreenAdv({
            callbacks: {
                onClose: function () {
                    // Действие после закрытия рекламы.
                },
                onError: function () {
                    // Действие в случае ошибки.
                }
            }
        })
    }, [])

    return (
        <AppBackground>
            <InstrumentPanel screen={screen}>
                {screen === 'start' && (
                    <>
                        <ButtonWrapper>
                            <Button onClick={onSwitchLeaderBord} iconName='leaderBord'
                                    size={getSizeForLayout({m: 30, t: 45, d: 80, isTable: isTableState, isDesktop: isDesktopState})} color='#1c188c'/>
                        </ButtonWrapper>
                        <ButtonWrapper>
                            <Button onClick={() => {
                                setShowLanguageModal(true);
                            }} iconName={lang}
                                    size={getSizeForLayout({m: 29, t: 44, d: 79, isTable: isTableState, isDesktop: isDesktopState})}/>
                        </ButtonWrapper>
                        <ButtonWrapper>
                            <Button onClick={onSwitchSound} iconName={sound ? 'soundOn' : 'soundOff'}
                                    size={getSizeForLayout({m: 30, t: 45, d: 80, isTable: isTableState, isDesktop: isDesktopState})} color='#1c188c'/>
                        </ButtonWrapper>
                    </>
                )}
                {screen === 'game' && (
                    <>
                        <ButtonWrapper>
                            <Button onClick={onSwitchSettings} iconName='settings' color='#1c188c'
                                    size={getSizeForLayout({m: 30, t: 45, d: 80, isTable: isTableState, isDesktop: isDesktopState})}/>
                        </ButtonWrapper>
                        {!ideaIsProcessing && <ButtonWrapper>
                            <Button onClick={() => {
                                yandexSdk.adv.showRewardedVideo({
                                    callbacks: {
                                        onOpen: () => {
                                            onStopMusic();
                                        },
                                        onRewarded: () => {
                                            eventEmitter.emit('showHint', true);
                                            setIdeaProcessing(true);
                                        },
                                        onClose: () => {
                                            if (sound) {
                                                onPlayMusic();
                                            }
                                        },
                                        onError: (e: any) => {
                                            console.log('Error while open video ad:', e);
                                        }
                                    }
                                })
                            }} iconName='idea' color='#1c188c' size={getSizeForLayout({m: 30, t: 45, d: 80, isTable: isTableState, isDesktop: isDesktopState})}/>
                        </ButtonWrapper>}
                    </>
                )}
            </InstrumentPanel>
            <BackgroundVideo autoPlay loop muted playsInline preload="auto">
                <source src={videoFile} type="video/mp4"/>
                Your browser does not support the video tag.
            </BackgroundVideo>
            {screen === 'start' && <StartScreen/>}
            {itemSize && screen === 'game' && <Game/>}
            {isShowLanguageModal && <LanguageModal isOpen={isShowLanguageModal} onClose={() => {
                setShowLanguageModal(false);
            }} />}
        </AppBackground>
    );
}

export default App;
